import { useState } from "react";

import AdminLayout from "@/components/admin/AdminLayout";
import { useAdminPageTitle } from "@/hooks/admin/useAdminPageTitle";

import { TABS, type TabKey } from "./ModuleSettings/constants";
import { FeatureFlagsTab } from "./ModuleSettings/FeatureFlagsTab";
import { ConfigurationTab } from "./ModuleSettings/ConfigurationTab";
import { AdministratorsTab } from "./ModuleSettings/AdministratorsTab";

// ---------------------------------------------------------------------------
// Main component
// ---------------------------------------------------------------------------

export default function ModuleSettings() {
  useAdminPageTitle("Paramètres — Modules");
  const [activeTab, setActiveTab] = useState<TabKey>("flags");

  return (
    <AdminLayout>
      <div className="space-y-6">
        {/* Page header */}
        <div className="space-y-1">
          <h1 className="font-display text-2xl font-semibold text-stone-900">
            Paramètres avancés
          </h1>
          <p className="text-sm text-stone-500">
            Gérez les drapeaux de fonctionnalités, la configuration du site et
            les administrateurs.
          </p>
        </div>

        {/* Tab bar */}
        <div
          className="flex gap-1 rounded-lg border p-1"
          style={{ borderColor: "#e7e0d6", background: "rgba(231,224,214,0.3)" }}
        >
          {TABS.map((tab) => {
            const isActive = activeTab === tab.key;
            const Icon = tab.icon;
            return (
              <button
                key={tab.key}
                type="button"
                onClick={() => setActiveTab(tab.key)}
                className={`flex items-center gap-2 rounded-md px-4 py-2 text-sm font-medium transition-all ${
                  isActive
                    ? "bg-white text-stone-800 shadow-sm"
                    : "text-stone-500 hover:text-stone-700"
                }`}
              >
                <Icon className="h-4 w-4" />
                {tab.label}
              </button>
            );
          })}
        </div>

        {/* Tab content */}
        {activeTab === "flags" && <FeatureFlagsTab />}
        {activeTab === "config" && <ConfigurationTab />}
        {activeTab === "admins" && <AdministratorsTab />}
      </div>
    </AdminLayout>
  );
}
